import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CrmCaseStatus from "./CrmCaseStatus";
import CrmCaseStatusTransfer from "./CrmCaseStatusTransfer";
import CrmCaseStatusTeamChange from "./CrmCaseStatusTeamChange";
import CrmCaseStatusFields from "./CrmCaseStatusFields";
import GridConfig from "../GridConfig";

export default class CrmCaseStatuses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            solutionId: props.SolutionId,
            controllerName: 'crm/casestatus',
            data: null,
            loading: true,
            configName: 'casestatus_grid',
            moduleName: 'وضعیتها'
        };
        this.state.filters = {
            crmTeamId: props.CrmTeamId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatus CrmTeamId={this.state.filters.crmTeamId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatus CrmTeamId={this.state.filters.crmTeamId} Caller={this} /> });
    }
    onTransfer(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatusTransfer Id={id} StatusList={this.state.data.records} Caller={this} /> });
    }
    onTeamChange(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatusTeamChange Id={id} Caller={this} /> });
    }    
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: false },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    showFields(crmCaseStatusId) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatusFields Caller={this} CrmCaseStatusId={crmCaseStatusId} /> });
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({
                field: f.field, flex: 4, headerName: f.caption, cellRenderer: (props) => {
                    return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)} style={{ "display": "flex", "flex-direction": "row", "align-items": "center", "gap": "2px" }} ><span style={{"width": "16px", "height": "16px", "display": "inline-block","border-radius": "100%", "backgroundColor":props.data.color }}></span>{props.data.title}</a>
                }
            });

            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a onClick={e => this.showFields(props.data.id)} className="hand text-success ms-2 me-2">
                <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> فیلدها</span>
                    </a>,
                    <a onClick={e => this.onTransfer(props.data.id)} className="hand text-warning ms-2 me-2">
                        <span className="nk-menu-text"><em className="icon ni ni-move"></em> انتقال</span>
                    </a>,
                    <a onClick={e => this.onTeamChange(props.data.id)} className="hand text-warning ms-2 me-2">
                        <span className="nk-menu-text"><em className="icon ni ni-move"></em> تغییر تیم</span>
                    </a>,
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
            ]}
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">وضعیت ها</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: this.hasPermission(197), print: false, pdf: false, excell: false, remove: false, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}